const config = {
  loginPath: '',
  loginPathT: 'https://t-perm.qinghotel.com',
  loginPathD: 'https://d-perm.qinghotel.com',
  loginPathD2: 'https://d2-perm.qinghotel.com',
  loginPathT1: 'https://t1-perm.qinghotel.com',
  loginPathProd: 'https://perm.qinghotel.com',
  loginUat: 'https://uat-perm.qinghotel.com',
  url: window.location.origin,
  finUrl: '',
  umengVersion: '',
  sNum: '',
  appid: 461,
  // appid: 1461
  /* 餐饮商户端/收银端在upm的appid */
  foodShopAppId: 14086,
  foodCashierAppId: 14087
}

if (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('192.') > -1) {
  config.loginPath = `https://${process.env.VUE_APP_BASE_DOMAIN_PREFIX && process.env.VUE_APP_BASE_DOMAIN_PREFIX + '-' || ''}perm.qinghotel.com`
  config.finUrl = 'https://b-financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279018891'
  config.sNum = 9
  // 本地联调轻赢宝线上时必须用正式 appId，否则 unifyLogin 后 toApp 找不到应用
  if ((process.env.VUE_APP_PMS_PROXY || '').includes('qingyingbao')) {
    config.appid = 1461
    config.foodShopAppId = 13315
    config.foodCashierAppId = 13316
  }
} else if (window.location.host.indexOf('t-') > -1) {
  config.loginPath = config.loginPathT
  config.finUrl = 'https://b-financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279019280'
  config.sNum = 4
} else if (window.location.host.indexOf('d2-') > -1) {
  config.loginPath = config.loginPathD2
  config.finUrl = 'https://b-financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279018891'
  config.sNum = 9
} else if (window.location.host.indexOf('d-') > -1) {
  config.loginPath = config.loginPathD
  config.finUrl = 'https://b-financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279018891'
  config.sNum = 9
} else if (window.location.host.indexOf('t1-') > -1) {
  config.loginPath = config.loginPathT1
  config.finUrl = 'https://b-financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279019299'
  config.sNum = 4
} else if (window.location.host.indexOf('uat-') > -1) {
  config.loginPath = config.loginUat
  config.finUrl = 'https://b-financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279019280'
  config.sNum = 4
} else {
  config.loginPath = config.loginPathProd
  config.finUrl = 'https://financial.qinghotel.com/merchantAccount'
  config.umengVersion = '1279005589'
  config.sNum = 4
  config.appid = 1461
    /* 正式域名必须使用餐饮系统在 UPM 的正式 AppID，避免上线前手工修改 */
  config.foodShopAppId = 13315
  config.foodCashierAppId = 13316
}

export default config

